<!-- eslint-disable no-mixed-spaces-and-tabs -->
<template>
  <div class="box">
    <div class="title">平台销售数据</div>
    <div class="databox" id="databox"></div>
  </div>
</template>
<script setup>
import * as echarts from "echarts";
import { onMounted } from "vue";

onMounted(() => {
  let mychart = echarts.init(document.getElementById("databox"));
  let xdata = ["3月", "4月", "5月", "6月", "7月", "8月", "9月"];
  let ydata = [502, 200, 332, 281, 398, 214, 445];
  let ydata2 = [550, 209, 369, 289, 458, 260, 385];
  let option = {
    legend: {
      right: "center",
      top: "1%",
      type: "plain",
      textStyle: {
        color: "#fff",
        fontSize: 14,
      },
      itemGap: 25,
      itemWidth: 18,
      icon: "path://M0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z",
      data: ["农资农产品", "农事服务"],
    },
    tooltip: {
      trigger: "axis",
    },
    grid: {
      top: "15%",
      left: "2%",
      right: "3%",
      bottom: "10%",
      containLabel: true,
    },
    xAxis: {
      type: "category",
      axisLabel: {
        color: "#fff",
      },
      boundaryGap: false,
      data: xdata,
      axisTick: {
        show: false,
      },
      axisLine: {
        show: true,
        lineStyle: {
          color: "#fff",
          width: 1,
        },
      },
    },
    dataZoom: {
      show: false,
      type: "slider",
      startValue: 0,
      endValue: 5,
    },
    yAxis: {
      name: "单位(万元)",
      nameTextStyle: {
        fontSize: 14,
        color: "#B4C0CC",
      },
      type: "value",
      min: 0,
      splitLine: {
        show: true,
        splitNumber: 5,
        lineStyle: {
          type: "dashed",
          color: "#999",
        },
      },
      axisLabel: {
        show: true,
        textStyle: {
          color: "#B4C0CC",
        },
      },
    },
    series: [
      {
        name: "农资农产品",
        type: "line",
        smooth: true,
        symbol: "none",
        lineStyle: {
          normal: {
            color: "#FFEC3D",
            shadowColor: "rgba(0, 0, 0, .3)",
            shadowBlur: 0,
          },
        },
        itemStyle: {
          normal: {
            color: "#FFEC3D",
          },
        },
        areaStyle: {
          normal: {
            color: new echarts.graphic.LinearGradient(
              0,
              0,
              0,
              1,
              [
                { offset: 0, color: "rgba(255,177,25,1.00)" },
                {
                  offset: 1,
                  color: "rgba(255,177,25,0)",
                },
              ],
              false
            ),
            shadowColor: "rgba(255,177,25,0.9)",
            shadowBlur: 20,
          },
        },
        data: ydata,
      },
      {
        name: "农事服务",
        type: "line",
        smooth: true,
        symbol: "none",
         lineStyle: {
          normal: {
            color: "#30FF61 ",
            shadowColor: "rgba(0, 0, 0, .3)",
            shadowBlur: 0,
          },
        },
        itemStyle: {
          normal: {
            color: "#30FF61 ",
          },
        },
        areaStyle: {
          normal: {
            color: new echarts.graphic.LinearGradient(
              0,
              0,
              0,
              1,
              [
                { offset: 0, color: "rgba(48,255,97,1)" },
                {
                  offset: 1,
                  color: "rgba(48,255,97,0)",
                },
              ],
              false
            ),
            shadowColor: "rgba(48,255,97,0.9)",
            shadowBlur: 20,
          },
        },
        data: ydata2,
      },
    ],
  };
  mychart.setOption(option);
  let timer2 = null;
  timer2 && clearInterval(timer2);
  let play = () => {
    let x0 = option.xAxis.data[0];
    let s0 = option.series[0].data[0];
    let s1 = option.series[1].data[0];
    option.xAxis.data.shift();
    option.xAxis.data.push(x0);
    option.series[0].data.shift();
    option.series[0].data.push(s0);
    option.series[1].data.shift();
    option.series[1].data.push(s1);
    mychart.setOption(option);
  };
  timer2 = setInterval(play, 2500);
  mychart.on("mouseover", function () {
    clearInterval(timer2);
  });
  mychart.on("mouseout", function () {
    timer2 = setInterval(play, 2500);
  });
});
</script>
<style lang="scss" scoped>
.box {
  width: 100%;
  height: 95%;
   @font-face {
    font-family: "YouSheBiaoTiHei";
    src: url("@/fonts/YouSheBiaoTiHei-2.ttf") format("truetype"); /* 全局字体 */
    font-weight: normal;
    font-style: normal;
  }
  .title {
    width: 100%;
    height: 40px;
    background-image: url("@/assets/mid-bg2.png");
    background-size: 100% 100%;
    color: #fff;
    font-size: 20px;
    padding-left: 38px;
    font-style: italic;
     font-family: YouSheBiaoTiHei;
  }
  .databox {
    width: 100%;
    height: 100%;
  }
}
</style>
